import { baseBackend } from "../../../api/base/baseUrl";

const URL_COMPANY = "api/v1/company";

export const createCompany = async (company) => {
  return await baseBackend.post(
    `${URL_COMPANY}/create`,
    JSON.stringify({ company }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const getListCompany = async () => {
  return await baseBackend.get(`${URL_COMPANY}/list`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getCompanyPermission = async (companyId) => {
  return await baseBackend.get(`${URL_COMPANY}/permission/${companyId}`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const createCompanyPermission = async (permissions, companyId) => {
  return await baseBackend.post(
    `${URL_COMPANY}/permission/create`,
    JSON.stringify({ permissions, companyId }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const updateCompanyPermission = async (permissions, companyId) => {
  return await baseBackend.put(
    `${URL_COMPANY}/permission/update`,
    JSON.stringify({ permissions, companyId }),
    { headers: { "Content-Type": "application/json" } }
  );
};
